<template>
    <popup :show="true" width="669px" height="740px" @on-close="onClose">
        <div class="title">面料信息</div>
        <div class="form-container">
            <div class="fabric-form-body">
                <div class="fabric-form-container">
                    <div class="type-tag">客供面料</div>
                    <Icon v-if="false" type="md-close" class="cursor remove" />
                    <div class="form-body">
                        <Upload
                            action="/"
                            :data="{ dir: 'template' }"
                            :before-upload="(file)=>onBeforeUpload(file)"
                            :show-upload-list="false"
                            :disabled="isView"
                        >
                            <div class="upload-img">
                                <template v-if="!form.image">
                                    <img src="@/assets/images/design/icon-add.png" alt="" class="upload-add-icon" />
                                    <div class="upload-add-text">上传面料图案</div>
                                </template>
                                <template v-else>
                                    <img :src="form.image | default_img" alt="" class="fabric-img">
                                </template>
                            </div>
                        </Upload>
                        <div class="form-right">
                            <div class="form-row">
                                <div class="form-label">名称*:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.fabric_name_cn" placeholder="请输入面料名称" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-label">编号:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.fabric_key" placeholder="请输入面料编号" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-label">幅宽:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.width_wide" placeholder="请输入面料幅宽,单位CM" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-label">成分:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.component" placeholder="请输入面料成分" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-label">颜色:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.color_name" placeholder="请输入面料颜色" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-label">克重:</div>
                                <div class="form-value">
                                    <input :disabled="isView" type="text" v-model="form.weight" placeholder="请输入面料克重" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="upload-spec cursor">
            <img class="icon" src="@/assets/images/team/icon-team-upload-blue.png" alt="">
            <span>继续上传面料</span>
        </div> -->
        <div class="btn-box">
            <div class="cancel-btn" @click="onClose">取消</div>
            <div v-if="!isView" class="confirm-btn" @click="onConfirmCreate">确认上传</div>
        </div>
    </popup>
</template>
<script> 
import { teamFileCreate, teamFileMove } from '@/api/index';
import Popup from '@/components/Popup.vue';
import { uploadFileToOSS } from "@/utils/oss";
export default {
  name:"FabricForm",
  components: {
    Popup,
  },
  props:{
    file:{
        type:Object,
        default:()=>({})
    },
    folderId:{
        type:String,
        default:''
    },
    teamId:{
        type:String,
        default:''
    },
    isView:{
        type:Boolean,
        default:false
    },
    viewInfo:{
        type:Object,
        default:()=>{}
    }
  },
  data(){
    return{
        form:{
            image:'',
            fabric_name_cn:'',
            fabric_key:'',
            width_wide:'',
            component:'',
            color_name:'',
            weight:'',
            name:'',
            path:''
        }
    }
  },
  mounted(){
    console.log('view-info',this.viewInfo);
    if(!this.isView){
        this.form.image = this.file.path;
        this.form.fabric_name_cn = this.file.name;
        this.form.name = this.file.name;
        this.form.path = this.file.path;
    }else{
        const {cover_img,key,name,image,color_name,fabric_key,fabric_name_cn,weight,width_wide,component} = this.viewInfo;
        this.form.image = cover_img || image;
        this.form.fabric_name_cn = name || fabric_name_cn;
        this.form.name = name || fabric_name_cn;
        this.form.fabric_key = key || fabric_key;
        this.form.color_name = color_name;
        this.form.weight = weight;
        this.form.width_wide = width_wide;
        this.form.component = component || '';
    }
  },
  methods:{
    async onFabricMoveIn(){
        try{
            const param = {};
            param.team_uuid = this.teamId;
            param.parent_directory_uuid = this.file.folder_uuid;
            param.file_uuid = this.file.file_uuid;
            param.type = 51;
            param.info = {...this.form};
            console.log('param-move-pattern',param);
            const {code,msg} = await teamFileMove(param);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.$emit('on-success');
            this.onClose();
        }catch(e){
            console.log('err-move-pattern',e);
            this.$layer.msg(e.msg);
        }
    },
    async onConfirmCreate(){
        try{
            if(this.file.is_move){
                this.onFabricMoveIn();
                return;
            }
            this.form.name = this.form.fabric_name_cn;
            const param = {};
            param.team_uuid = this.teamId;
            param.directory_uuid = this.folderId;
            param.type = 52;
            param.info = this.form;
            console.log('param==>create_pattern',param);
            const {code,msg} = await teamFileCreate(param);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.$emit('on-success');
            this.onClose();
        }catch(e){
            console.log('err-create-pattern',e);
            this.$layer.msg(e.msg);
        }
    },
    onBeforeUpload(file) { 
        uploadFileToOSS(file, 'template').then(url => {
           console.log('上传面料文件成功',url);
           this.form.image = url;
           this.form.name = file.name;
           this.form.path = url;
        })
        return false;
    },
    onClose(){
        console.log('aaa');
        this.$emit('on-close',true);
    }
  }
};
</script>
<style scoped lang="scss">
.title{
    color:#1a1a1a;
    font-size:24px;
    line-height:44px;
    width:100%;
    text-align:center;
}
.form-container{
    width:100%;
    max-height:650px;
    overflow-y:scroll;
    display:flex;
    flex-direction:column;
    row-gap:10px;
    &::-webkit-scrollbar{
        display:none;
    }
    .fabric-form-body{
    width:100%;
    padding:0 30px;
    display:flex;
    flex-direction:column;
    .fabric-form-container{
        background:#fafafa;
        border-radius:5px;
        position:relative;
        padding:0 20px;
        width:100%;
        display:flex;
        flex-direction:column;
        .type-tag{
            position:absolute;
            top:0;
            left:0;
            background:#000000;
            border-radius:5px 0 5px 0;
            color:#ffffff;
            width:70px;
            height:25px;
            line-height:25px;
            text-align:center;
        }
        .remove{
            position:absolute;
            top:10px;
            right:10px;
        }
        .form-body{
            width:100%;
            display:flex;
            align-items:center;
            column-gap:16px;
            padding:37px 20px 30px 20px;
            .upload-img{
                width:138px;
                height:138px;
                border-radius:8px;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                background:#ffffff;
                .upload-add-icon{
                    width:26px;
                    height:26px;
                }
                .upload-add-text{
                    color:#999999;
                    font-size:14px;
                }
                .fabric-img{
                    width:100%;
                    height:100%;
                }
            }
            .form-right{
                flex:1;
                display:flex;
                flex-direction:column;
                .form-row{
                    width:100%;
                    border-bottom:1px solid #ebebeb;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    .form-label{
                        color:#666666;
                        font-size:14px;
                        line-height:36px;
                    }
                    .form-value{
                        flex:1;
                        input{
                            width:100%;
                            border:none;
                            outline:none;
                            background:transparent;
                        }
                    }
                }
            }
        }
        
    }
}
}

.upload-spec{
    display:flex;
    align-items:center;
    column-gap:10px;
    color:#629ffa;
    font-size:14px;
    margin-left:40px;
    margin-top:29px;
    .icon{
        width:20px;
        height:20px;
    }
}
.form-two-col{
    display:flex;
    column-gap:20px;
    .col-item{
        flex:1;
    }
}
.btn-box{
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    column-gap:10px;
    margin:40px 0;
    .cancel-btn{
        width:150px;
        height:38px;
        border-radius:8px;
        border:1px solid #e5e5e5;
        text-align:center;
        line-height:38px;
        color:#333333;
        font-size:14px;
        cursor:pointer;
    }
    .confirm-btn{
        width:180px;
        height:38px;
        line-height:38px;
        border-radius:8px;
        text-align:center;
        color:#ffffff;
        background:#ff5967;
        font-size:14px;
        cursor:pointer;
    }
}

::v-deep .ivu-radio-checked .ivu-radio-inner{
    border-color:#ff5967;
    &::after{
        background-color:#ff5967;
    }
}
::v-deep .ivu-radio-focus{
    box-shadow:none;
    -webkit-box-shadow:none;
}
</style>